require('./fairway-hit-chart.jade')

FairwayHitChartDirective = ->
  createChartOptions = (fairwayHitData, target) ->
    chart:
      renderTo: target[0]
      type: 'pie'
      backgroundColor: 'transparent'
    plotOptions:
      pie:
        borderWidth: 0
        shadow: false
        center: ['50%', '50%']
        enableMouseTracking: false
        dataLabels:
          enabled: false
    tooltip:
      enabled: false
    title:
      floating: true
      y: 28
      text: fairwayHitData
      style:
        'fontSize': '14px'
        'color': '#008484'
    credits:
      enabled: false
    series: [
      size: 60,
      innerSize: 50,
      data: [
        color: '#008484'
        y: parseFloat(fairwayHitData)
      ,
        color: '#87b6b6'
        y: 100 - parseFloat(fairwayHitData)
      ]
    ]
  restrict: "A"
  replace: false
  templateUrl: "dashboard/fairway-hit/fairway-hit-chart.jade"
  scope:
    fairwayHitData: '=fairwayHitData'
  link: (scope, element) ->
    target = element.find(".chart")
    scope.$watch (-> scope.fairwayHitData), ->
      new Highcharts.Chart createChartOptions(scope.fairwayHitData, target)

module.exports = FairwayHitChartDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/dashboard/fairway-hit/fairway-hit-chart-directive.coffee